import { NFT_TYPE } from 'config/constants/nftTypes'
import { useTranslation } from 'contexts/Localization'
import useTheme from 'hooks/useTheme'
import { useMemo } from 'react'
import styled from 'styled-components'
import { getArgoMintedUrl, getVVSMinerMoleMintedUrl } from 'utils/mintedNftCollectionUrls'
import { Text, Flex, Button } from 'vvs-uikit'

const MoleGroups = styled.img`
  width: 100%;
`

const ArgoLogo = styled.img`
  max-width: 150px;
`

export const EmptyNFTs: React.FC<{ type?: NFT_TYPE }> = ({ type }) => {
  const { t } = useTranslation()
  const { theme } = useTheme()

  const renderContent = useMemo<{ logo: React.ReactNode; title: string; desc: string; redirectUrl: string }>(() => {
    let content

    switch (type) {
      case NFT_TYPE.ARGO:
        content = {
          logo: <ArgoLogo alt="argo_logo" src="/images/igo/logo/0x2a59804792EDB39889aA144417c6437a48Fdf9fa.png" />,
          title: t('No Argonauts NFT found'),
          desc: t('Seems you don’t have any Argonauts NFT in wallet. Time to check out the collection at marketplace.'),
          redirectUrl: getArgoMintedUrl(),
        }
        break
      case NFT_TYPE.MINER_MOLE:
      default:
        content = {
          logo: <MoleGroups alt="miner_moles_group" src="/images/xVVS/miner_moles_group.png" />,
          title: t('No Miner Moles NFT found'),
          desc: t('Seems you don’t have any Miner Moles in wallet. Time to check out the collection at marketplace.'),
          redirectUrl: getVVSMinerMoleMintedUrl(),
        }
        break
    }

    return content
  }, [type, t])

  return (
    <Flex flexDirection="column" gap="30px" padding="0 24px 24px 24px">
      <Flex justifyContent="center">{renderContent.logo}</Flex>
      <Flex flexDirection="column" gap="6px" alignItems="center">
        <Text fontFamily="Effra" fontSize="28px" lineHeight="33px">
          {renderContent.title}
        </Text>
        <Text fontSize="16px" lineHeight="24px" color={theme.colors.textSubtle} textAlign="center">
          {renderContent.desc}
        </Text>
      </Flex>
      <Button
        variant="primary"
        scale="lg"
        onClick={() => {
          window.open(renderContent.redirectUrl)
        }}
      >
        {t('Go to Marketplace')}
      </Button>
    </Flex>
  )
}
